module.exports = __webpack_public_path__ + "media/images/left-arrow-button-white-99d4a38054dd4bde751f3588230f17fc.svg";